// extracted by mini-css-extract-plugin
module.exports = {"threeItems":"index-module--threeItems--AvS3h","item":"index-module--item--3_ltt"};